// Normalisation of the errors surfaced to the interface.
// The Edge Functions answer with the { code, message, details?, request_id } envelope
// (services-api); Supabase and the network layer raise plain Error objects.
import { enveloppeErreur } from '@horizon/types';
import type { CodeErreur } from '@horizon/types';

/** French message shown for each error code of the API envelope. */
const MESSAGE_PAR_CODE: Readonly<Record<CodeErreur, string>> = {
  SAISIE_INVALIDE: 'Saisie invalide : vérifiez les champs signalés.',
  NON_AUTHENTIFIE: 'Session expirée : reconnectez-vous.',
  ACCES_REFUSE: 'Accès non autorisé.',
  INTROUVABLE: 'Élément introuvable ou supprimé.',
  CONFLIT: 'Cette action entre en conflit avec une modification récente.',
  REGLE_VIOLEE: 'Action refusée : une règle métier bloque cette opération.',
  ERREUR_INTERNE: 'Une erreur interne est survenue. Réessayez dans un instant.',
};

/** Extract the request identifier of an API envelope, for support and traceability. */
export function identifiantRequete(cause: unknown): string | null {
  const analyse = enveloppeErreur.safeParse(cause);
  return analyse.success ? analyse.data.request_id : null;
}

/**
 * Convert any thrown value into a French message suitable for display.
 * The API envelope wins over the raw technical message.
 */
export function messageErreur(cause: unknown, repli: string): string {
  const analyse = enveloppeErreur.safeParse(cause);
  if (analyse.success) {
    const message = analyse.data.message.trim();
    return message.length > 0 ? message : MESSAGE_PAR_CODE[analyse.data.code];
  }
  if (cause instanceof Error && cause.message.trim().length > 0) {
    return cause.message;
  }
  return repli;
}
